import { render, staticRenderFns } from "./recommendGoods.vue?vue&type=template&id=2a7374f2&scoped=true"
import script from "./recommendGoods.vue?vue&type=script&lang=js"
export * from "./recommendGoods.vue?vue&type=script&lang=js"
import style0 from "./recommendGoods.vue?vue&type=style&index=0&id=2a7374f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7374f2",
  null
  
)

export default component.exports